<script setup>
import { computed } from 'vue'
import { useTranslaterStore } from '@/stores/translater'
import docsLicense from '@/docs/license.pdf'
import docsPrivacy from '@/docs/privacy.pdf'

const translaterStore = useTranslaterStore()

const getTranslate = computed(() => translaterStore.getTranslate)
</script>

<template>
    <footer class="asw-footer">
        <div class="asw-footer__docs">
            <a class="asw-footer__docs-link" :href="docsLicense" target="_blank">{{ getTranslate.DOCS_LECENSE }}</a>
            <a class="asw-footer__docs-link" :href="docsPrivacy" target="_blank">{{ getTranslate.DOCS_PRIVACY }}</a>
        </div>
        <div class="asw-footer__bottom">
            <span class="asw-footer__bottom-copyright">
                {{ getTranslate.COPYRIGHT }}
            </span>
            <router-link to="/certificates" class="asw-footer__bottom-cert">
                <span class="material-icons asw-footer__bottom-cert-icon">gpp_good</span>
            </router-link>
        </div>
    </footer>
</template>
